module.exports = __webpack_public_path__ + "img/brand-value-titel.b692dee7.png";